module.exports = __webpack_public_path__ + "static/media/tkg_move.8ee2df88.png";